function wrapNonLocalizedMessage(message) {
  return {
    id: "non-localized-message",
    values: { message: message.toString() },
  };
}

export default wrapNonLocalizedMessage;
